export interface SectionState {
  id: string;
  status: SectionStatus;
  durationSeconds: number;
}


export type SectionStatus = 'unknown' | 'not-attempted' | 'incomplete' | 'completed';

export function statusAsNumber(status: SectionStatus) {
  switch (status) {
    case 'unknown':
      return 0;
    case 'not-attempted':
      return 1;
    case 'incomplete':
      return 2;
    case 'completed':
      return 3;
  }
}

export function defaultSectionState(id: string): SectionState {
  return {
    id,
    status: 'not-attempted',
    durationSeconds: 0
  };
}

